import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  local = { 
    courses: {},
    coupons: {},
    course: {},
    page: ''
  }

  constructor(
    public db: AngularFireDatabase
  ) { 
    this.loadSettings();
  }
  
  loadSettings(){
    this.db.list('courses', ref => ref.orderByChild('order')).valueChanges().subscribe(data=>{
      this.local['courses'] = data;
      this.saveSettings();
    });

    this.db.list('cupones', ref => ref.orderByChild('general')).valueChanges().subscribe(data=>{
      this.local['coupons'] = data;
      this.saveSettings();
    });

    if(localStorage.getItem('local')){
      this.local = JSON.parse(String(localStorage.getItem('local')));
    }
  }

  saveSettings(){
    localStorage.setItem('local', JSON.stringify(this.local));
  }

  deleteSettings(){
    this.local['courses'] = {};
    this.local['coupons'] = {};
    this.local['course'] = {};
    this.local['page'] = '';
    this.saveSettings();
  }

}
